import RSVP from 'rsvp';

export function imagePreloader(images:any[string], success?:Function, fail?:Function, timeout:number = 3000):void {
    const promises = images.map((image) => {
        return preloadImage(image, timeout);
    });

    RSVP.allSettled(promises).then((results) => {
        const failed = results.filter((res) => {
            return res.state !== 'fulfilled';
        });

        if(typeof(success) !== 'undefined' && !failed.length) {
            success.call(false, images);
        }

        if(typeof(fail) !== 'undefined' && failed.length) {
            fail.call(false);
        }
    });
}

function preloadImage(image:string, timeout:number) {
    const promise = new RSVP.Promise((resolve, reject) => {
        const img = new Image;
        const that = this;
        img.src = image;
        img.onload = () => {
            resolve(image);
        };
        img.onerror = (error) => {
            reject(error);
        };
        // let client = new XMLHttpRequest();
        // client.open("GET", image, true);
        // client.onreadystatechange = onStatusChange;
        // // client.timeout = 3000;
        // client.send();

        // function onStatusChange() {
        //     if (this.readyState === this.DONE) {
        //         if (this.status === 200) {
        //             resolve(this.response);
        //         } else { 
        //             reject(this);
        //         }
        //     };
        // }
    });
    
    return promise;
}